import { render, staticRenderFns } from "./ObjectiveList.vue?vue&type=template&id=50220b4f&scoped=true"
import script from "./ObjectiveList.vue?vue&type=script&lang=js"
export * from "./ObjectiveList.vue?vue&type=script&lang=js"
import style0 from "./ObjectiveList.vue?vue&type=style&index=0&id=50220b4f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50220b4f",
  null
  
)

export default component.exports